module.exports = __webpack_public_path__ + "static/media/landing-image-mobile@3x.3913b66c.jpg";